import React from 'react';

import ContentLoader, { Rect } from 'react-content-loader/native';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '~/utils/device';

const DEFAULT_WIDTH = SCREEN_WIDTH - 48;

const Loader: React.FC = () => {
  return (
    <ContentLoader
      animate
      width={SCREEN_WIDTH}
      height={SCREEN_HEIGHT}
      viewBox={`0 0 ${SCREEN_WIDTH} ${SCREEN_HEIGHT}`}
    >
      <Rect x="0" y="0" rx="3" ry="3" width={DEFAULT_WIDTH} height="20" />
      <Rect x="0" y="26" rx="3" ry="3" width={DEFAULT_WIDTH} height="20" />
      <Rect x="0" y="52" rx="3" ry="3" width={SCREEN_WIDTH / 2} height="20" />

      <Rect x="0" y="104" width={DEFAULT_WIDTH} height="90" />
      <Rect x="0" y="210" width={DEFAULT_WIDTH} height="90" />
      <Rect x="0" y="316" width={DEFAULT_WIDTH} height="90" />
      <Rect x="0" y="422" width={DEFAULT_WIDTH} height="90" />
    </ContentLoader>
  );
};

export default Loader;
